import { __awaiter } from "tslib";
/**
 * 移动端本地编辑 local server 通用接口实现
 */
import axios from 'axios';
import qs from 'qs';
import { SUCCESS_CODE } from './constants';
const LOCAL_SERVER_EVENT = {
    CHANGED: 'localServerChanged', // 客户端派发的 local_server 变更事件
};
export default class LocalServer {
    constructor() {
        this.localServerPromise = Promise.resolve('');
        this.initLocalServer();
        // 监听客户端派发的 local_server 变更事件
        document.addEventListener(LOCAL_SERVER_EVENT.CHANGED, () => this.initLocalServer());
    }
    get(path, params = {}, extra = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const finalPath = yield this.getAPIPath(path);
            return axios
                .get(finalPath, Object.assign({ params,
                paramsSerializer(params) {
                    return qs.stringify(params);
                } }, extra))
                .then((res) => res.data)
                .catch((error) => {
                throw new Error(error.message);
            });
        });
    }
    // 返回 ArrayBuffer
    getFile(path, params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            let result = yield this.get(path, params, {
                responseType: 'arraybuffer',
            });
            try {
                // 如果JSON.parse(enc.decode(new Uint8Array(data)))不报错，说明后台返回的是json对象，则弹框提示
                // 如果JSON.parse(enc.decode(new Uint8Array(data)))报错，说明返回的是文件流，进入catch，返回数据流
                const enc = new TextDecoder('utf-8');
                result = JSON.parse(enc.decode(new Uint8Array(result))); // 转化成json对象
                return result;
            }
            catch (err) {
                return {
                    code: SUCCESS_CODE,
                    data: result,
                };
            }
        });
    }
    post(path, data, params, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            const finalPath = yield this.getAPIPath(path);
            return axios(finalPath, {
                headers: headers || {
                    'Content-Type': 'application/json; charset=UTF-8',
                },
                method: 'POST',
                data,
                params,
            })
                .then((res) => res.data)
                .catch((error) => {
                throw new Error(error.message);
            });
        });
    }
    initLocalServer() {
        var _a;
        if (!((_a = window.mqq) === null || _a === void 0 ? void 0 : _a.invoke)) {
            throw new Error('window.mqq is not exist');
        }
        this.localServerPromise = new Promise((resolve) => {
            window.mqq.invoke('docx', 'getLocalServer', {}, (result) => {
                resolve(result.data);
            });
        });
    }
    getAPIPath(path) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const isIOS = /(iphone|ipad|ipod)/i.test((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent);
            const localServer = yield this.localServerPromise;
            return `${isIOS ? 'https' : 'http'}://${localServer}${path}`;
        });
    }
}
//# sourceMappingURL=local-server-api.js.map